import InlineSVG from "react-inlinesvg";
import styled from "styled-components/macro";

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
  border-radius: 6px;
  padding: 2px 8px 2px 4px;
  border: 1px solid var(--grey-3);
  width: fit-content;
  font-weight: 500;
  transition: all 0.2s;

  &:hover {
    border-color: var(--grey-2);
  }

  svg {
    height: 18px;
    width: 18px;
    path {
      fill: var(--grey-0);
    }
  }

  .label {
    font-size: 12px;
    color: var(--grey-0);
  }
`;

export const Chiclet = ({ src, label, onClick }) => {
  return (
    <Container onClick={onClick}>
      <InlineSVG
        src={src}
        className="type-icon"
      />
      <p className="label">{label}</p>
    </Container>
  );
};
